/**
 * Created by liux on 17/12/26.
 */
function finishH5Page(data, cb) {
  window.callBridge && window.callBridge('finishH5Page', data, function(response) {
    if (cb) {
      cb(response);
    }
  });

}

export default finishH5Page;
